/* ib-blog.js — índice lateral y botón de compartir del artículo.
   Sin dependencias. Si falla, la página sigue completa: el índice y el
   botón son mejoras, no requisitos. */
(function () {
  'use strict';

  function slug(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '')
      .slice(0, 80);
  }

  function buildToc() {
    var body = document.querySelector('.ib-post__body');
    var list = document.querySelector('.ib-toc ol');
    if (!body || !list) return;
    var heads = body.querySelectorAll('h2');
    if (heads.length < 2) return;
    var used = {};
    heads.forEach(function (h) {
      var id = h.id || slug(h.textContent);
      if (!id) return;
      if (used[id]) id += '-' + (++used[id]); else used[id] = 1;
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
    if ('IntersectionObserver' in window) {
      var links = list.querySelectorAll('a');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          links.forEach(function (l) { l.removeAttribute('aria-current'); });
          var cur = list.querySelector('a[href="#' + e.target.id + '"]');
          if (cur) cur.setAttribute('aria-current', 'true');
        });
      }, { rootMargin: '-96px 0px -70% 0px' });
      heads.forEach(function (h) { io.observe(h); });
    }
  }

  function share() {
    var btn = document.querySelector('[data-ib-share]');
    if (!btn) return;
    var msg = btn.parentNode.querySelector('.ib-share__msg');
    btn.addEventListener('click', function () {
      var data = { title: btn.getAttribute('data-title'), url: btn.getAttribute('data-url') };
      if (navigator.share) {
        navigator.share(data).catch(function () {});
        return;
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(data.url).then(function () {
          btn.setAttribute('data-copied', 'true');
          if (msg) msg.textContent = btn.getAttribute('data-ok') || 'Enlace copiado';
          setTimeout(function () {
            btn.removeAttribute('data-copied');
            if (msg) msg.textContent = '';
          }, 2500);
        });
      }
    });
  }

  /* Nosotros: la línea del protocolo se dibuja al entrar en pantalla (un solo momento) */
  function timeline() {
    var t = document.querySelector('[data-ib-timeline]');
    if (!t) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { t.classList.add('is-on'); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { t.classList.add('is-on'); io.disconnect(); } }); }, { threshold: 0.35 });
    io.observe(t);
  }
  /* Video de YouTube: fachada con miniatura; el iframe se carga al dar clic */
  function video() {
    document.querySelectorAll('[data-ib-video]').forEach(function (v) {
      var b = v.querySelector('.ib-video__play');
      if (!b) return;
      b.addEventListener('click', function () {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + v.getAttribute('data-ib-video') + '?autoplay=1&rel=0';
        f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        f.allowFullscreen = true;
        f.title = b.getAttribute('aria-label') || 'Video';
        b.replaceWith(f);
      });
    });
  }
  /* Video de TikTok: el reproductor oficial se carga solo al dar clic */
  function tiktok() {
    document.querySelectorAll('[data-ib-tiktok]').forEach(function (v) {
      var a = v.querySelector('.ib-tiktok__play');
      if (!a) return;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var q = document.createElement('blockquote');
        q.className = 'tiktok-embed';
        q.setAttribute('cite', a.getAttribute('data-cite'));
        q.setAttribute('data-video-id', v.getAttribute('data-ib-tiktok'));
        q.style.maxWidth = '340px'; q.style.minWidth = '280px'; q.style.margin = '0';
        q.appendChild(document.createElement('section'));
        a.replaceWith(q);
        var s = document.createElement('script');
        s.src = 'https://www.tiktok.com/embed.js'; s.async = true;
        document.body.appendChild(s);
      });
    });
  }
  /* Mapas de sucursales: el iframe de Google Maps se carga cuando la tarjeta entra en pantalla */
  function maps() {
    var els = document.querySelectorAll('[data-ib-map]');
    if (!els.length) return;
    var load = function (el) {
      if (el.querySelector('iframe')) return;
      var f = document.createElement('iframe');
      f.src = el.getAttribute('data-ib-map');
      f.loading = 'lazy';
      f.referrerPolicy = 'no-referrer-when-downgrade';
      f.title = 'Mapa de la sucursal';
      el.appendChild(f);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(load); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { load(e.target); io.unobserve(e.target); } }); }, { rootMargin: '200px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() { buildToc(); share(); timeline(); video(); tiktok(); maps(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
